import { useCallback, useState } from "react";

const INITIAL_CURSOR = { x: 0, y: 0 };

const useEventMarkerHover = () => {
  const [hoveredEvent, setHoveredEvent] = useState(null);
  const [hoveredEventColor, setHoveredEventColor] = useState(null);
  const [hoverCursor, setHoverCursor] = useState(INITIAL_CURSOR);

  const handleMarkerHoverStart = useCallback((event, markerColor, nativeEvent) => {
    setHoveredEvent(event);
    setHoveredEventColor(markerColor);
    setHoverCursor({
      x: nativeEvent.clientX,
      y: nativeEvent.clientY,
    });
  }, []);

  const handleMarkerHoverMove = useCallback((nativeEvent) => {
    setHoverCursor({
      x: nativeEvent.clientX,
      y: nativeEvent.clientY,
    });
  }, []);

  const clearMarkerHover = useCallback(() => {
    setHoveredEvent(null);
    setHoveredEventColor(null);
  }, []);

  const resetHover = useCallback(() => {
    setHoveredEvent(null);
    setHoveredEventColor(null);
    setHoverCursor(INITIAL_CURSOR);
  }, []);

  return {
    hoveredEvent,
    hoveredEventColor,
    hoverCursor,
    handleMarkerHoverStart,
    handleMarkerHoverMove,
    clearMarkerHover,
    resetHover,
  };
};

export default useEventMarkerHover;
